import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  pageTitle: () => __(translations.directoryAddressesTab.pageTitle, 'Addresses'),
  add: () => __(translations.directoryAddressesTab.add, 'Add'),
};
